<template>
  <el-dialog
    :modal-append-to-body="false"
    width="70%"
    :title="hasIban ? $t('re-conciliation.confirm') : ''"
    :visible.sync="dialogVisible"
  >
    <div v-loading.lock="loading">
      <div v-if="hasIban">
        <div class="items">
          <el-row
            type="flex"
            justify="space-between"
            class="item pb-20"
          >
            <span class="item-property">
              {{ $t("re-conciliation.to-reconcile") }}
            </span>
            <span class="item-value">
              {{
                (reConciliationData.reconcileAvailable / 100).toLocaleString(
                  $localeString,
                  {
                    style: "currency",
                    currency: reConciliationData.currency,
                  }
                )
              }}
            </span>
          </el-row>
          <el-row
            v-if="
              reConciliationData.payoutFee > 0 &&
                reConciliationData.reconcileAvailable > 0
            "
            style="margin-top: 10px"
          >
            <el-col>
              <el-alert
                :description="$t('re-conciliation.payout-fee', { payoutFee })"
                type="warning"
                show-icon
                center
                :closable="false"
                class="pay-out-alert"
              />
            </el-col>
          </el-row>
          <el-row
            v-if="reConciliationData.payoutThreshold"
            style="margin-top: 10px; text-align: center"
          >
            <el-col>
              <p>
                {{
                  $t("re-conciliation.payout-fee-threshold", {
                    payoutFeeThreshold,
                  })
                }}
              </p>
            </el-col>
          </el-row>
        </div>
        <div slot="footer">
          <el-row>
            <el-col
              :lg="11"
              :md="11"
              :sm="24"
              :sx="24"
              class="mt-5"
            >
              <el-button
                :disabled="
                  reConciliationData.reconcileAvailable <= 0 ||
                    reConciliationData.payoutFee >=
                    reConciliationData.reconcileAvailable
                "
                type="primary"
                class="primary-button"
                @click="reConciliation"
              >
                {{ $t("form.confirm") }}
              </el-button>
            </el-col>
            <el-col
              :lg="{ span: 11, offset: 2 }"
              :md="{ span: 11, offset: 2 }"
              :sm="24"
              :sx="24"
              class="mt-5"
            >
              <el-button
                type="primary"
                class="cancel-button"
                @click="dialogVisible = false"
              >
                {{ $t("form.cancel") }}
              </el-button>
            </el-col>
          </el-row>
          <el-row class="bank-statement-des">
            <el-col>
              <p v-html="$t('re-conciliation.bank-statement')" />
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-else>
        <el-row class="no-iban-alert">
          <el-col>
            <div class="no-iban-alert-wrapper">
              <p v-html="$t('pay-out.no-iban-alert')" />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import authHelpers from "@/plugins/auth-helpers.js";

export default {
  name: "ConfirmEmployeeReconciliation",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    hasIban: false,
    loading: false,
    reConciliationData: {
      currency: "EUR",
      reconcileAvailable: 0,
      payoutFee: 0,
      payoutThreshold: 0,
    },
  }),
  computed: {
    dialogVisible: {
      get: function() {
        return this.visible;
      },
      set: function(value) {
        this.$emit("update:visible", value);
      },
    },
    payoutFee() {
      return (this.reConciliationData.payoutFee / 100).toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
      });
    },
    payoutFeeThreshold() {
      return (this.reConciliationData.payoutThreshold / 100).toLocaleString(
        "de-DE",
        {
          style: "currency",
          currency: "EUR",
        }
      );
    },
  },
  watch: {
    visible: async function(value) {
      this.loading = true;
      if (value) {
        await authHelpers.isCurrentUserHasIban().then((response) => {
          this.hasIban = response;
        });
        await this.getCurrentUser().then((user) => {
          this.$adminApi
            .get(`/api/v1/employees/${user.attributes.sub}/balance`)
            .then((response) => {
              let balances = [];
              if (Array.isArray(response.data) && response.data.length) {
                balances = response.data;
              } else if (
                Object.keys(response.data).length !== 0 &&
                response.data.constructor === Object
              ) {
                balances = [response.data];
              }

              const employee = balances.find((el) => el.role === "employee");
              if (employee != null) {
                Object.assign(this.reConciliationData, employee);
              }
            });
        });
      }

      this.loading = false;
    },
  },
  methods: {
    /* eslint-disable */
    reConciliation() {
      this.$adminApi.post("/api/v1/qrcodes").then((response) => {
        // this.$store.dispatch("setReConciliationResponse", response.data);
        this.$store.dispatch("setReConciliationResponse", {
          status: "Success",
        });
        this.$router.push({ name: "ReConciliationThankYou" });
      });
    },
  },
};
</script>

<style lang="scss">
.no-iban-alert {
  p {
    text-align: left;
    line-height: 1.5;
    color: #ff8a00;
    font-size: 20px;
    word-break: break-word;
  }

  i {
    color: #ff8a00;
    font-size: 32px;
  }

  &-wrapper {
    display: flex;
    gap: 16px;
  }
}

.bank-statement-des {
  margin-top: 10px;

  p {
    text-align: left;
    line-height: 1.5;
    color: #ff8a00;
    max-width: 85%;
    font-size: 20px;
  }

  b {
    font-weight: bold;
  }
}

.pay-out-alert {
  .el-alert__description {
    font-size: 16px;
    line-height: 1.2;
    color: #000 !important;
  }
}
</style>
<style scoped lang="scss">
.items {
  .item {
    border-bottom: 1px solid #e5e5e5;

    &-property {
      color: #000000;
      font-family: "Raleway Regular", serif;
      font-size: 16px;
    }

    &-value {
      color: #000000;
      font-family: "Raleway Bold", serif;
      font-size: 16px;
    }
  }
}
</style>
